import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { icons } from '../../../assets';
import { Tooltip } from 'antd';
// eslint-disable-next-line
export const UserPerfilMerz = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const { arrayData } = useSelector((state) => state.table);
    const { typeAdmin } = useSelector((state) => state.auth)
    const [pointsUpper, setpointsUpper] = useState(0)
    const [timeTotalUser, setTimeTotalUser] = useState(0)
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    // const { proyects } = useSelector((state) => state.vrlSlice);
    const [pageSelected, setpageSelected] = useState(0)

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    // eslint-disable-next-line
    const [dataFilterPerUser, setFileterData] = useState([])

    const formatedDate = (date) => {
        const fecha = new Date(date);
        return fecha.toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }


    const userHighPoints = (dataFilterPerUser) => {
        const element = dataFilterPerUser.reduce((max, elemento) =>
            parseInt(elemento.puntaje) > parseInt(max.puntaje) ? elemento : max, { puntaje: '0/100' }
        );
        setpointsUpper(dataFilterPerUser.length ? element.puntaje : 0);
    }

    const userTimeTotal = (dataFilterPerUser) => {
        const sumaTiempoTotal = dataFilterPerUser.reduce((total, elemento) => {
            const minutos = parseInt(elemento.tiempo_total.split(' ')[0], 10);
            return total + minutos;
        }, 0);
        const horas = Math.floor(sumaTiempoTotal / 60);
        const minutosRestantes = sumaTiempoTotal % 60;

        setTimeTotalUser(horas + ":" + minutosRestantes)
    }


    const onchangePage = (next) => {
        setpageSelected(actual => {
            const suma = actual + next
            if (suma >= dataFilterPerUser.length) {
                return 0
            }
            if (suma <= -1) {
                return dataFilterPerUser.length - 1
            }
            else {
                return suma
            }

        })
    }

    const contarAprobados = (obj, keys) => {
        return keys.reduce((count, key) => count + (obj[key] === "Aprobado" ? 1 : 0), 0);
    }

    useEffect(() => {

        // if (typeAdmin === "VRT" && proyectSelected === "66fafd1d92bbc20883798c43") {
        // console.log(arrayData)


        // historia 
        // marcaje 
        // aplicacion 
        const conjunts = arrayData
            .filter(obj => obj.matricula === matricula)
            .map(obj => ({
                ...obj,
                Fecha_y_hora: formatedDate(obj.Fecha_y_hora),
                intro: contarAprobados(obj, ["Introduccion_Introduccion", "Introduccion_Tutorial", "Introduccion_Ultrasonidos"]),
                historias: contarAprobados(obj, ["Expedientes_HistoriaClinica", "Expedientes_HistoriasClinicas"]),
                cuello: contarAprobados(obj, ["Unidad1_AplicacionCuello", "Unidad1_HistoriaClinica", "Unidad1_MarcajeCuello"]),
                escote: contarAprobados(obj, ["Unidad2_AplicacionEscote", "Unidad2_HistoriaClinica", "Unidad2_MarcajeEscote"]),
                cara: contarAprobados(obj, ["Unidad3_AplicacionCara", "Unidad3_HistoriaClinica", "Unidad3_MarcajeCara"]),
                final: contarAprobados(obj, ["Unidad4_Final"])
            }));

        console.log(conjunts)
        setFileterData(conjunts);
        userHighPoints(conjunts);
        userTimeTotal(conjunts)
    }, [responses, proyectSelected, arrayData, Fecha_y_hora, matricula, typeAdmin, nameUser])


    return (
        <div className='w-full h-full flex flex-col py-6 px-10'>
            <div className='pl-4 w-full h-5/12 flex items-center'>
                <div className='w-10 h-10 rounded-full flex justify-center items-center bg-blue-600 mr-4'>
                    <p className='text-white font-semibold text-xs'> {nameUser.split(" ")[0].substring(0, 2).toUpperCase()}</p>
                </div>
                <InfoUser title={"Nombre"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />
                {<InfoUser title={"Fecha"} text={new Date(Fecha_y_hora).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })} />}
            </div>
            <div className="pl-16 pt-6">
                <p className='text-black text-2xl font-semibold leading-5'>Curso: {proyectSelected.name}</p>
            </div>
            <div className='w-full  flex h-12 justify-center gap-x-8 py-3'>
                <div className='flex w-[210px]'>
                    <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Tiempo total invertido</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{timeTotalUser} hrs.</p>
                    </div>
                </div>
                <div className='flex w-[210px]'>
                    <img src={icons.shield} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Puntaje más alto</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{pointsUpper}</p>
                    </div>
                </div>
                <div className='flex w-[210px]'>
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Calificado por el usuario</p>
                        <div className='flex  items-center'>
                            <p className='text-xl font-medium text-[#282828] leading-5 pr-2'>
                                {dataFilterPerUser[pageSelected]?.RateApp || "n/a"}
                            </p>
                            {
                                [...Array(5)].map((_, index) => (
                                    <svg
                                        key={index}
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <polygon
                                            points="12,2 15,9 22,9 17,14 18,21 12,18 6,21 7,14 2,9 9,9"
                                            fill={index < (dataFilterPerUser[pageSelected]?.RateApp || 0) ? "#F6CE27" : "#E6E6E6"}
                                        />
                                    </svg>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full flex justify-center items-center pt-4">
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(-1) }}
                        className='h-full flex justify-center items-center mr-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 transform rotate-180' alt="" />
                        </div>
                    </div>
                }
                {/*  */}
                <div className='w-[744px] h-[390px] rounded-3xl shadow-3xl py-8 px-4'>
                    <div className='flex w-full gap-4 pb-4'>
                        {/* <div className='flex gap-2'>
                            <img src={icons.initialDate} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868]'>Fecha inicial</p>
                                <p>{dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}</p>
                            </div>
                        </div> */}
                        <InfoIntent icon={icons.initialDate} title={'Fecha inicial'} data={dataFilterPerUser[pageSelected]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.endDate} title={'Fecha final'} data={dataFilterPerUser[pageSelected]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Estatus</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.Porcentaje_total || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.Porcentaje_total.split('%')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Puntaje</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] + '%' || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <InfoIntent icon={icons.progress} title={'Progreso'} data={dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}></InfoIntent> */}
                        {/* <InfoIntent icon={icons.pointsSheld} title={'Puntaje'} data={dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}></InfoIntent> */}
                    </div>
                    <div className='w-full h-10 bg-3366FF rounded flex'>
                        <div className='w-9/12 flex justify-start items-center px-2'>
                            <p className='text-white font-bold text-xs'>Módulos</p>
                        </div>
                        <div className='w-3/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Lecciones</p>
                        </div>

                    </div>
                    {/* epp */}
                    <div className='w-full flex py-2'>
                        <div className='w-9/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Intro</p>
                        </div>
                        <div className='w-3/12 flex justify-center gap-2'>
                                <CubeIntent correct={dataFilterPerUser[pageSelected]?.Introduccion_Introduccion === "Aprobado"} title={"Introduccion_Introduccion"}></CubeIntent>
                                <CubeIntent correct={dataFilterPerUser[pageSelected]?.Introduccion_Tutorial === "Aprobado"} title={"Introduccion_Tutorial"}></CubeIntent>
                                <CubeIntent correct={dataFilterPerUser[pageSelected]?.Introduccion_Ultrasonidos === "Aprobado"} title={"Introduccion_Ultrasonidos"}></CubeIntent>

                        </div>


                    </div>
                    {/* previo a utilizar  */}
                    <div className='w-full flex py-2'>
                        <div className='w-9/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Historias clínicas</p>
                        </div>
                        <div className='w-3/12 flex justify-center gap-2'>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Expedientes_HistoriaClinica === "Aprobado"} title={"Expedientes_HistoriaClinica"}></CubeIntent>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Expedientes_HistoriasClinicas === "Aprobado"} title={"Expedientes_HistoriasClinicas"}></CubeIntent>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>

                        </div>


                    </div>
                    {/* despliegue */}
                    <div className='w-full flex py-2'>
                        <div className='w-9/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Cuello</p>
                        </div>
                        <div className='w-3/12 flex justify-center gap-2'>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad1_HistoriaClinica === "Aprobado"} title={"Unidad1_HistoriaClinica"}></CubeIntent>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad1_MarcajeCuello === "Aprobado"} title={"Unidad1_MarcajeCuello"}></CubeIntent>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad1_AplicacionCuello === "Aprobado"} title={"Unidad1_AplicacionCuello"}></CubeIntent>
                        </div>


                    </div>
                    {/*  */}
                    <div className='w-full flex py-2'>
                        <div className='w-9/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Escote</p>
                        </div>
                        <div className='w-3/12 flex justify-center gap-2'>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad2_HistoriaClinica === "Aprobado"} title={"Unidad2_HistoriaClinica"}></CubeIntent>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad2_MarcajeEscote === "Aprobado"} title={"Unidad2_MarcajeEscote"}></CubeIntent>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad2_AplicacionEscote === "Aprobado"} title={"Unidad2_AplicacionEscote"}></CubeIntent>

                        </div>


                    </div>
                    <div className='w-full flex py-2'>
                        <div className='w-9/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Cara</p>
                        </div>
                        <div className='w-3/12 flex justify-center gap-2'>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad3_HistoriaClinica === "Aprobado"} title={"Unidad3_HistoriaClinica"}></CubeIntent>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad3_MarcajeCara === "Aprobado"} title={"Unidad3_MarcajeCara"}></CubeIntent>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad3_AplicacionCara === "Aprobado"} title={"Unidad3_AplicacionCara"}></CubeIntent>

                        </div>


                    </div>
                    {/*  */}
                    <div className='w-full flex py-2'>
                        <div className='w-9/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Conclusión</p>
                        </div>
                        <div className='w-3/12 flex  gap-2 justify-center'>
                            <CubeIntent correct={dataFilterPerUser[pageSelected]?.Unidad4_Final === "Aprobado"} title={"Unidad4_Final"}></CubeIntent>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                        </div>


                    </div>

                </div>
                {/*  */}
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(1) }}
                        className='h-full flex justify-center items-center pl-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 ' alt="" />
                        </div>
                    </div>
                }
            </div>
            <div className='w-full flex justify-center gap-x-2 pt-4'>
                {dataFilterPerUser.length >= 2 && <PageViewer pageSelected={pageSelected} dataFilterPerUser={dataFilterPerUser.length}></PageViewer>}

            </div>
        </div>
    )
}


const PageViewer = ({ pageSelected, dataFilterPerUser }) => {
    const rows = []
    for (let index = 0; index < dataFilterPerUser; index++) {
        rows.push(
            <div key={index} className={`w-2 h-2 
                ${pageSelected === index ? "bg-[#14A6E0] bg-opacity-100" : "bg-black bg-opacity-40"}
                 rounded-full`}></div>
        )
    }
    return rows
}

const InfoUser = ({ title, text }) => {
    return (
        <div className='w-2/6 h-full flex items-center'>
            <p className='text-[#686868]  text-xs font-medium leading-5'>{title}: </p>
            <p className='text-[#454545] text-xs font-normal pl-2 leading-5'>{text}</p>
        </div>
    )
}

const CubeIntent = ({ correct, title }) => {
    return (
        <Tooltip placement="rightTop" title={
            <div className='bg-[#2A3A45]'>
                <p className='text-white'>{title}</p>
            </div>
        } color="#2A3A45" overlayInnerStyle={{ color: "#2A3A45" }}>

            <div className={`w-6 h-6 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold
                                    ${correct ? 'bg-[#89EB7E]' : 'bg-[#F2B840]'}`}>

            </div>
        </Tooltip>
    )
}


const InfoIntent = ({ icon, title, data }) => {
    return (
        <div className='flex gap-2'>
            <img src={icon} className="w-6 h-6" alt="icono de fecha" />
            <div>
                <p className='text-[#686868] text-xs font-medium leading-5'>{title}</p>
                <p className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>{data}</p>
            </div>
        </div>
    )
}


export default UserPerfilMerz
